
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import "../../styles/Login/main.scss"
import envConfig from "../../config/config";

const ApiCategoryDonutGraph = () => {
    const [responseData, setResponseData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    `${envConfig.REACT_APP_APIREPO_READ}/apirepo/v0.1/category/count`
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();


                if (data?.data?.tagCounts) {
                    setResponseData(data.data.tagCounts);
                } else {
                    console.error("Unexpected API structure:", data);
                    setResponseData([]);
                }
            } catch (error) {
                console.error("Error fetching component count data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return <div className="flex items-center justify-center h-full w-full">
            <div className="w-12 h-12 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
        </div>;
    }

    if (!responseData.length) {
        return <div>No data available.</div>;
    }

    const labels = responseData
        .filter(item => item?.tag && item.tag.toString().trim() !== "")
        ?.map(item => item.tag.toString());

    const ComponentCount = responseData
        .filter(item => item?.count !== null)
        ?.map(item => item.count);

    const options = {
        chart: {
            type: 'donut',
        },
        stroke: {
            width: 1
        },
        labels: labels,
        theme: {
            monochrome: {
                enabled: true,
                color: "#0077cf"
            },
        },
        legend: {
            show: true,
            position: "right",
            floating: false,
            horizontalAlign: "center",
            labels: {
                usePointStyle: true,
            },
            markers: {
                shape: "square",
            },
            itemMargin: {
                horizontal: 10,
                vertical: 5,
            },
            fontSize: "12px",
            width: 600,
            height: 250,
            color: "blue",
            formatter: (seriesName) => seriesName,
        },

    };

    const series = ComponentCount;

    return (
        <div id="chart" className="h-full">
            <Chart options={options} series={series} type="donut" height={"100%"} />
        </div>
    );
};

export default ApiCategoryDonutGraph;
